import React from 'react';
import {BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Queue from "./components/Queue";
import NotFound from "./components/NotFound";

function App() {
    return (
        <Router>
            <Switch>
                <Route path="/system/:systemName/queue/:queueName" component={Queue} />
                <Route component={NotFound} />
            </Switch>
        </Router>
    );
}

export default App;